$(document).ready(function () {
  // eq-collection-testimonial js start here
  
  function PDPTestimonialSlider() {
    let $sliders = $('.js-eq-collection-testimonial-slider');

    if ($sliders.length > 0) {
      $sliders.each(function () {
        let $this = $(this);
        if ($this.hasClass('slick-initialized')) {
          $this.slick('unslick'); // Destroy existing instance before reinitializing
        }
        $this.slick({
          slidesToShow: 3,
          slidesToScroll: 1,
          autoplay: false,
          autoplaySpeed: 6000,
          pauseOnHover: true,
          arrows: false,
          infinite: true,
          centerMode: true,
          dots: true,
          responsive: [
            {
              breakpoint: 992,
              settings: {
                slidesToShow: 1,
                centerMode: false,
              }
            }
          ]
        });
      });
    }
  }

PDPTestimonialSlider();
  // eq-collection-testimonial js END here

  // eq-faq-new js start here 
  $(document).on("click", ".js-eq-faq-new-box-header", function () {
    if ($(this).parent().hasClass("active")) {
      $(this).parent().removeClass("active");
      $(this).parent().find('.js-eq-faq-new-box-body').slideUp();
    } else {
      $(".js-eq-faq-new-box").removeClass("active");
      $(this).parent().addClass("active");
      $(".js-eq-faq-new-box-body").slideUp(500);
      $(this).parent().find('.js-eq-faq-new-box-body')
        .slideDown(500);
    }
  });
  $('.js-eq-faq-new-box').first().addClass('active');
  $('.js-eq-faq-new-box').first().find('.js-eq-faq-new-box-body').slideDown();
  // eq-faq-new js END here

  // announcement-bar js strat here
  $(".js-eq-announcement-bar-v2-close-btn").click(function () {
    $(".js-eq-announcement-bar-v2").hide();
  });
  // announcement-bar js END here

  // collection js start here

  if ($('.eq-collection .card__content .card__heading').length > 0) {
    $('.eq-collection .card > .card__content .card__heading .full-unstyled-link').matchHeight({
      byRow: true,
    });
  };
  if ($('.eq-collection .card__content .eq-collection-benefits-badge').length > 0) {
    $('.eq-collection .card__content .eq-collection-benefits-badge').matchHeight({
      byRow: true,
    });
  };
  if ($('.eq-collection .card__content .card-information .eq-product-strength').length > 0) {
    $('.eq-collection .card__content .card-information .eq-product-strength').matchHeight({
      byRow: true,
    });
  };

  const collectionContainer = document.querySelector('.eq-collection');

  const observer = new MutationObserver(() => {
    $('.eq-collection .card > .card__content .card__heading .full-unstyled-link').matchHeight({
      byRow: true,
    });
    $('.eq-collection .card__content .eq-collection-benefits-badge').matchHeight({
      byRow: true,
    });
    $('.eq-collection .card__content .card-information .eq-product-strength').matchHeight({
      byRow: true,
    });
  });

  const config = {
    childList: true,
    subtree: true,
  };
  if (collectionContainer) {
    observer.observe(collectionContainer, config);
  } else {
    console.error('Collection container not found.');
  }
  // collection js END here


  // great-choice section js strat here
  if ($('.js-eq-great-choice-slider').length > 0) {
    $('.js-eq-great-choice-slider').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      autoplay: false,
      arrows: false,
      infinite: false,
      centerMode: false,
      dots: false,
      responsive: [
        {
          breakpoint: 1300,
          settings: {
            slidesToShow: 3,
          }
        },
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 2,
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            arrows: true,
            prevArrow: '<button type="button" aria-label="Previous" class="prev-arrow"><svg width="10" height="13" viewBox="0 0 10 13" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8 1L3 6.5L8 12" stroke="#A82758" stroke-width="3"/></svg></button>',
            nextArrow: '<button type="button" aria-label="Next" class="next-arrow"><svg width="10" height="13" viewBox="0 0 10 13" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M2 1L7 6.5L2 12" stroke="#A82758" stroke-width="3"/></svg></button>',
            adaptiveHeight: true,
          }
        }
      ]
    });
  }
  $('.eq-great-choice__slider .box__text a').matchHeight({
    byRow: true,
  });
  // great-choice section js end here

  // product-detail-slider js start here
  if ($('.js-eq-product-slide-for').length > 0) {
    $('.js-eq-product-slide-for').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      fade: false,
      speed: 900,
      arrows: true,
      prevArrow: '<button type="button" aria-label="Previous" class="prev-arrow"><svg width="10" height="13" viewBox="0 0 10 13" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8 1L3 6.5L8 12" stroke="#A82758" stroke-width="3"/></svg></button>',
      nextArrow: '<button type="button" aria-label="Next" class="next-arrow"><svg width="10" height="13" viewBox="0 0 10 13" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M2 1L7 6.5L2 12" stroke="#A82758" stroke-width="3"/></svg></button>',
      fade: true,
      infinite: false,
      asNavFor: '.js-eq-product-slide-now',
    });
    $('.js-eq-product-slide-now').slick({
      slidesToShow: 5,
      slidesToScroll: 1,
      asNavFor: '.js-eq-product-slide-for',
      dots: false,
      arrows: true,
      prevArrow: $(".js-product-detail-arrow-prev"),
      nextArrow: $(".js-product-detail-arrow-next"),
      speed: 900,
      focusOnSelect: true,
      vertical: false,
      verticalScrolling: false,
      infinite: false,
      responsive: [
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 4.7,
            vertical: false,
            verticalScrolling: false,
          }
        },
        {
          breakpoint: 390,
          settings: {
            slidesToShow: 3.7,
            vertical: false,
            verticalScrolling: false,
          }
        },
      ]
    });
  }
  // product-detail-slider js end here

  // product-detail tab js start here
  $('.js-eq-product-tab li').click(function () {
    let tabId = $(this).attr('data-tab');
    let tabText = $(this).text();
    $(this).addClass('active').siblings().removeClass('active');
    $('#tab-' + tabId).fadeIn().siblings().hide();
    $('.js-drop-btn').text(tabText);
  });

  $('.js-eq-product-tab li').first().addClass('active');
  $('.eq-product-tab-details__content').first().fadeIn();

  // let getActiveTabText = $('.js-eq-product-tab li.active').text();
  // $('.js-drop-btn').text(getActiveTabText);

  // $('.js-drop-btn').click(function () {
  //   $(this).toggleClass("active");
  //   $(".eq-product-tab").slideToggle();
  // });

  // function dropDown() {
  //   if ($(window).width() < 992) {
  //     $('.js-eq-product-tab li').click(function () {
  //       $(".js-eq-product-tab").slideUp();
  //       $(".js-drop-btn").removeClass("active");
  //     });
  //   }
  // }
  // dropDown();
  // $(window).on('resize', function () {
  //   dropDown();
  // });
  // product-detail tab js end here

  $('.eq-product-detail-new__right .eq-product-detail-count__wrap .box label .box__text').matchHeight({
    byRow: true,
  });

  // cuttr js 
  $('.eq-product-tab-details__content .metafield-rich_text_field').Cuttr({
    //options here
    truncate: 'characters',
    length: 200,
    readMore: true,
    readMoreText: 'Read More',
    readLessText: 'Read Less',
    ending: '...',
    readMoreBtnPosition: 'inside',
    readMoreBtnTag: 'button',
  });

    // cuttr js 
    $('.js-eq-collection-des-sec .metafield-rich_text_field').Cuttr({
      //options here
      truncate: 'characters',
      length: 763,
      readMore: true,
      readMoreText: 'Read More',
      readLessText: 'Read Less',
      ending: '',
      readMoreBtnPosition: 'inside',
      readMoreBtnTag: 'a',
    });

  if ($(window).width() > 767) {
    $('.eq-great-choice__slider .box__text .box-title').matchHeight({
      byRow: true,
    });
    $('.eq-great-choice__slider .box__text-badge').matchHeight({
      byRow: true,
    });
    $('.eq-great-choice__slider .box__text form').matchHeight({
      byRow: true,
    });
  }
  $(window).on('resize', function () {
    if ($(window).width() > 767) {
      $('.eq-great-choice__slider .box__text .box-title').matchHeight({
        byRow: true,
      });
      $('.eq-great-choice__slider .box__text-badge').matchHeight({
        byRow: true,
      });
      $('.eq-great-choice__slider .box__text form').matchHeight({
        byRow: true,
      });
    }
  });
  $(window).on('reload', function () {
    if ($(window).width() > 767) {
      $('.eq-great-choice__slider .box__text .box-title').matchHeight({
        byRow: true,
      });
      $('.eq-great-choice__slider .box__text-badge').matchHeight({
        byRow: true,
      });
      $('.eq-great-choice__slider .box__text form').matchHeight({
        byRow: true,
      });
    }
  });

  // quiz page testimonial js start here 
  if ($('.js-eq-quiz-result-testimonial-slider').length > 0) {
    $('.js-eq-quiz-result-testimonial-slider').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: false,
      autoplaySpeed: 6000,
      pauseOnHover: true,
      arrows: false,
      infinite: true,
      centerMode: false,
      dots: true,
    });
  }
  // quiz page testimonial js end here 

  // quiz page tab js start here 
  $('.js-eq-quiz-result-tab li').click(function () {
    let tabId = $(this).attr('data-quiz-tab');
    let tabText = $(this).text();
    $(this).addClass('active').siblings().removeClass('active');
    $(this).parents(".eq-quiz-result-tab-details").find('.quiz-tab-' + tabId).fadeIn().siblings().hide();
    $(this).parents(".eq-quiz-result-tab-details").find('.js-eq-quiz-result-tab-dropbtn').text(tabText);
  });

  $('.eq-quiz-result__wrap .box').each(function(){
    $(this).find('.js-eq-quiz-result-tab li').first().addClass('active');
    $(this).find('.eq-quiz-result-tab-details__content').first().fadeIn();
    let getQuizActiveTabText = $(this).find('.js-eq-quiz-result-tab li.active').text();
    $(this).find('.js-eq-quiz-result-tab-dropbtn').text(getQuizActiveTabText);
  });

  $('.js-eq-quiz-result-tab-dropbtn').click(function () {
    $(this).toggleClass("active");
    $(this).parents(".eq-quiz-result-tab-details").find(".js-eq-quiz-result-tab").slideToggle();
  });

  function quizDropDown() {
    if ($(window).width() < 1200) {
      $('.js-eq-quiz-result-tab li').click(function () {
          $(this).parents(".eq-quiz-result-tab-details").find(".js-eq-quiz-result-tab").slideUp();
          $(this).parents(".eq-quiz-result-tab-details").find(".js-eq-quiz-result-tab-dropbtn").removeClass("active");
      });
    }
  }
  quizDropDown();
  $(window).on('resize', function () {
    quizDropDown();
  });
  // quiz page tab js end here 

  $('.js-review-tab li.js_review_tab').click(function () {
    let tabId = $(this).attr('pdp-data-tab');
    let tabText = $(this).text();

    $(this).addClass('active').siblings().removeClass('active');
    $('.js-review-tab-content').fadeOut();
    $('.pdp-data-tab-' + tabId).fadeIn();

    $('.js-drop-btn').text(tabText);

    setTimeout(function () {
      PDPTestimonialSlider();
    }, 200);
  });

  $('.js-review-tab li.js_review_tab').first().addClass('active');
  $('.js-review-tab-content').first().fadeIn();
});

$(document).ready(function () {

  const widget = document.querySelector("recharge-subscription-widget");

  if (widget && widget.shadowRoot) {
    function injectCSSIntoShadow(shadowRoot, cssID, styles) {
      if (shadowRoot && !shadowRoot.querySelector('#' + cssID)) {
        const style = document.createElement("style");
        style.id = cssID;
        style.textContent = styles;
        shadowRoot.appendChild(style);
      }
    }

    // Inject CSS into the first shadow root (recharge-subscription-widget)
    injectCSSIntoShadow(widget.shadowRoot, "custom-style-1", `
          .rc-selection__root .rc-purchase-option {
              border-radius: 4px !important;
              border: 1px solid #BFBFBF;
            }
            .rc-selection__root .rc-purchase-option[rc-selected] {
              border: 1px solid #A82758;
            }
            .rc-selection__root .rc-purchase-option__label {
              color: #212121;
              margin: 0 24px;
              padding: 18.5px 0 !important;
              flex-wrap: wrap;
            }
            .rc-selection__root .rc-purchase-option[rc-selected] .rc-purchase-option__label{
              color: #A82758;
            }
            .rc-selection__root .rc-purchase-option__selector {
              font-size: 20px;
              font-family: 'Mulish', sans-serif;
              font-weight: 700;
              text-transform: capitalize;
            }
            .rc-purchase-option__checked-indicator {
              width: 100%;
              max-width: 16px;
            }
            .rc-selection__root .rc-purchase-option__prices {
              flex-direction: row !important;
            }
            .rc-purchase-option__prices .rc-price {
              font-family: 'Mulish', sans-serif;
              color: #000;
              font-size: 20px;
              line-height: 1.2;
              font-weight: 800;
            }
            .rc-purchase-option__prices .rc-price.text-muted {
              color: rgba(0, 0, 0, 0.6);
              margin: 0 8px 0 0;
            }
            .rc-selection__root .rc-purchase-option[rc-selected] .rc-purchase-option__label .rc-purchase-option__prices .rc-price {
              color: #A82758;
            }
            .rc-selection__root .rc-purchase-option[rc-selected] .rc-purchase-option__label .rc-purchase-option__prices .rc-price.text-muted {
              color: #c2688a;
            }
            .rc-selection__root .rc-purchase-option__sub-container {
              padding: 0 25px 26px;
              gap: 14px;
              position: relative;
            }
            .rc-selection__root .rc-purchase-option__sub-container:after {
              content: " ";
              position: absolute;
              width: 48px;
              height: 48px;
              background-image: url(https://cdn.shopify.com/s/files/1/0265/5164/8355/files/subscribe-Icon.gif?v=1739861370);
              background-size: contain;
              background-repeat: no-repeat;
              bottom: 26px;
              right: 20px;
              z-index: 99999;
            }
            .rc-selection__root .rc-purchase-option.rc-selection__onetime .rc-purchase-option__label {
              padding: 19.5px 0 !important;
            }

            @media screen and (max-width: 767px) {
              .rc-selection__root .rc-purchase-option__selector {
                font-size: 17px;
                line-height: 1.17;
              }
              .rc-selection__root .rc-purchase-option__label {
                margin: 0 14px;
                padding: 14px 0 !important;
              }
              .rc-purchase-option__prices .rc-price.text-muted {
                margin: 0 4px 0 0;
              }
              .rc-selection__root .rc-purchase-option__sub-container {
                padding: 0 15px 19px;
                gap: 10px;
              }
              .rc-selection__root .rc-purchase-option__sub-container:after {
                bottom: 19px;
                right: 10px;
              }
              .rc-selection__root .rc-purchase-option.rc-selection__onetime .rc-purchase-option__label {
                padding: 14.5px 0 !important;
              }
              .rc-selection__root .rc-purchase-option.rc-selection__onetime .rc-purchase-option__label .rc-purchase-option__prices .rc-price {
                font-size: 17px;
              }
            }
            @media screen and (max-width: 345px) {
              .rc-selection__root .rc-purchase-option__sub-container:after {
                width: 35px;
                height: 35px;
              }
            }
       `);

    // Check for rc-benefits inside the first shadow root
    setTimeout(() => {
      const rcBenefits = widget.shadowRoot.querySelector("rc-benefits"); // Ensure this selector is correct
      if (rcBenefits && rcBenefits.shadowRoot) {
        injectCSSIntoShadow(rcBenefits.shadowRoot, "custom-style-2", `
                .rc-benefits__list {
                  padding-top: 12px;
                  border-top: 1px solid #BFBFBF;
                }
                .rc-benefits__list ul li {
                  font-family: 'Open Sans', sans-serif;
                  font-size: 16px;
                  line-height: 1.7;
                  font-weight: 400;
                  color: #333232;
                  background-image: url(/cdn/shop/files/checkmark-icon.png?v=1737636149);
                  background-repeat: no-repeat;
                  background-position: left top 6px;
                  background-size: 15px;
                  padding: 0 0 0 25px;
                }
                .rc-benefits__list ul li:last-child {
                  margin: 0;
                }
                .rc-benefits__list ul li:before {
                  display: none;
                }
                @media screen and (max-width: 767px) {
                  .rc-benefits__list {
                    padding-top: 11px;
                  }
                  .rc-benefits__list ul li {
                    background-size: 14px;
                    padding: 0 0 0 24px;
                    font-size: 14px;
                  }
                }
             `);
      }
    }, 500);

    setTimeout(() => {
      const rcSelling = widget.shadowRoot.querySelector("rc-selling-plans"); // Ensure this selector is correct
      if (rcSelling && rcSelling.shadowRoot) {
        injectCSSIntoShadow(rcSelling.shadowRoot, "custom-style-3", `
              .rc-plans-dropdown {
                display: flex;
                align-items: center;
              }
              .rc-plans-dropdown svg {
                display: none;
              }
              .rc-plans-dropdown .rc-plans__label {
                font-family: 'Mulish', sans-serif;
                color: #212121;
                font-size: 14px;
                line-height: 1.7;
                font-weight: 800;
                text-transform: uppercase;
                letter-spacing: 0.08em;
                margin: 0 13px 0 0;
              }
              .rc-plans-dropdown select.rc-plans-dropdown__select {
                width: 100%;
                max-width: 240px;
                border: 1px solid #BFBFBF;
                color: #333232;
                border-radius: 4px;
                font-family: 'Open Sans', sans-serif;
                background-image: url(https://cdn.shopify.com/s/files/1/0265/5164/8355/files/subscription-dropdown-icon.svg?v=1739856222);
                background-repeat: no-repeat;
                background-position: center right 17px;
                background-size: 14px;
                font-size: 14px;
                line-height: 2;
                padding: 7px 16px;
                cursor: pointer;
                outline: none;
                box-shadow: none;
              }
              @media screen and (max-width: 767px) {
                .rc-plans-dropdown {
                  flex-direction: column;
                  align-items: flex-start;
                }
                .rc-plans-dropdown .rc-plans__label {
                  font-size: 13px;
                  line-height: 1.8;
                  margin: 0 0 3px;
                }
                .rc-plans-dropdown select.rc-plans-dropdown__select {
                  font-size: 13px;
                  padding: 6px 16px;
                  background-size: 13px;
                  background-position: center right 21px;
                  max-width: 230px;
                }
              }
              @media screen and (max-width: 345px) {
                .rc-plans-dropdown select.rc-plans-dropdown__select {
                  background-position: center right 10px;
                  max-width: 200px;
                }
              }
             `);
      }
    }, 500);

    setTimeout(() => {
      const rcRadioIcon = widget.shadowRoot.querySelector("rc-radio-icon"); // Ensure this selector is correct
      if (rcRadioIcon && rcRadioIcon.shadowRoot) {
        injectCSSIntoShadow(rcRadioIcon.shadowRoot, "custom-style-4", `
            .rc-unchecked-icon {
              width: 16px;
              height: 16px;
              border-radius: 100%;
              background-color: #F2F0EF;
            }
            .rc-unchecked-icon rect {
              stroke:#BFBFBF;
            }
            .rc-checked-icon {
              width: 16px;
              height: 16px;
              border-radius: 100%;
              background-color: #A82758;
            }
            .rc-checked-icon circle {
              fill: #fff;
            }
          `);
      }
    }, 500);
    setTimeout(() => {
      const rcRadioIcon2 = widget.shadowRoot.querySelector("[rc-not-selected] rc-radio-icon"); // Ensure this selector is correct
      if (rcRadioIcon2 && rcRadioIcon2.shadowRoot) {
        injectCSSIntoShadow(rcRadioIcon2.shadowRoot, "custom-style-5", `
            .rc-unchecked-icon {
              width: 16px;
              height: 16px;
              border-radius: 100%;
              background-color: #F2F0EF;
            }
            .rc-unchecked-icon rect {
              stroke:#BFBFBF;
            }
            .rc-checked-icon {
              width: 16px;
              height: 16px;
              border-radius: 100%;
              background-color: #A82758;
            }
            .rc-checked-icon circle {
              fill: #fff;
            }
          `);
      }
    }, 500);

    // Observe changes in both shadow roots
    const observer = new MutationObserver(() => {
      injectCSSIntoShadow(widget.shadowRoot, "custom-style-1", `
            .rc-selection__root .rc-purchase-option {
              border-radius: 4px !important;
              border: 1px solid #BFBFBF;
            }
            .rc-selection__root .rc-purchase-option[rc-selected] {
              border: 1px solid #A82758;
            }
            .rc-selection__root .rc-purchase-option__label {
              color: #212121;
              margin: 0 24px;
              padding: 18.5px 0 !important;
              flex-wrap: wrap;
            }
            .rc-selection__root .rc-purchase-option[rc-selected] .rc-purchase-option__label{
              color: #A82758;
            }
            .rc-selection__root .rc-purchase-option__selector {
              font-size: 20px;
              font-family: 'Mulish', sans-serif;
              font-weight: 700;
              text-transform: capitalize;
            }
            .rc-purchase-option__checked-indicator {
              width: 100%;
              max-width: 16px;
            }
            .rc-selection__root .rc-purchase-option__prices {
              flex-direction: row !important;
            }
            .rc-purchase-option__prices .rc-price {
              font-family: 'Mulish', sans-serif;
              color: #000;
              font-size: 20px;
              line-height: 1.2;
              font-weight: 800;
            }
            .rc-purchase-option__prices .rc-price.text-muted {
              color: rgba(0, 0, 0, 0.6);
              margin: 0 8px 0 0;
            }
            .rc-selection__root .rc-purchase-option[rc-selected] .rc-purchase-option__label .rc-purchase-option__prices .rc-price {
              color: #A82758;
            }
            .rc-selection__root .rc-purchase-option[rc-selected] .rc-purchase-option__label .rc-purchase-option__prices .rc-price.text-muted {
              color: #c2688a;
            }
            .rc-selection__root .rc-purchase-option__sub-container {
              padding: 0 25px 26px;
              gap: 14px;
              position: relative;
            }
            .rc-selection__root .rc-purchase-option__sub-container:after {
              content: " ";
              position: absolute;
              width: 48px;
              height: 48px;
              background-image: url(https://cdn.shopify.com/s/files/1/0265/5164/8355/files/subscribe-Icon.gif?v=1739861370);
              background-size: contain;
              background-repeat: no-repeat;
              bottom: 26px;
              right: 20px;
              z-index: 99999;
            }
            .rc-selection__root .rc-purchase-option.rc-selection__onetime .rc-purchase-option__label {
              padding: 19.5px 0 !important;
            }

            @media screen and (max-width: 767px) {
              .rc-selection__root .rc-purchase-option__selector {
                font-size: 17px;
                line-height: 1.17;
              }
              .rc-selection__root .rc-purchase-option__label {
                margin: 0 14px;
                padding: 14px 0 !important;
              }
              .rc-purchase-option__prices .rc-price.text-muted {
                margin: 0 4px 0 0;
              }
              .rc-selection__root .rc-purchase-option__sub-container {
                padding: 0 15px 19px;
                gap: 10px;
              }
              .rc-selection__root .rc-purchase-option__sub-container:after {
                bottom: 19px;
                right: 10px;
              }
              .rc-selection__root .rc-purchase-option.rc-selection__onetime .rc-purchase-option__label {
                padding: 14.5px 0 !important;
              }
              .rc-selection__root .rc-purchase-option.rc-selection__onetime .rc-purchase-option__label .rc-purchase-option__prices .rc-price {
                font-size: 17px;
              }
            }
            @media screen and (max-width: 345px) {
              .rc-selection__root .rc-purchase-option__sub-container:after {
                width: 35px;
                height: 35px;
              }
            }
          `);

      const rcBenefits = widget.shadowRoot.querySelector("rc-benefits");
      if (rcBenefits && rcBenefits.shadowRoot) {
        injectCSSIntoShadow(rcBenefits.shadowRoot, "custom-style-2", `
                .rc-benefits__list {
                  padding-top: 12px;
                  border-top: 1px solid #BFBFBF;
                }

                .rc-benefits__list ul li {
                  font-family: 'Open Sans', sans-serif;
                  font-size: 16px;
                  line-height: 1.7;
                  font-weight: 400;
                  color: #333232;
                  background-image: url(/cdn/shop/files/checkmark-icon.png?v=1737636149);
                  background-repeat: no-repeat;
                  background-position: left top 6px;
                  background-size: 15px;
                  padding: 0 0 0 25px;
                }
                .rc-benefits__list ul li:last-child {
                  margin: 0;
                }
                .rc-benefits__list ul li:before {
                  display: none;
                }
                @media screen and (max-width: 767px) {
                  .rc-benefits__list {
                    padding-top: 11px;
                  }
                  .rc-benefits__list ul li {
                    background-size: 14px;
                    padding: 0 0 0 24px;
                    font-size: 14px;
                  }
                }
             `);
      }
      const rcSelling = widget.shadowRoot.querySelector("rc-selling-plans");
      if (rcSelling && rcSelling.shadowRoot) {
        injectCSSIntoShadow(rcSelling.shadowRoot, "custom-style-3", `
              .rc-plans-dropdown {
                display: flex;
                align-items: center;
              }
              .rc-plans-dropdown svg {
                display: none;
              }
              .rc-plans-dropdown .rc-plans__label {
                font-family: 'Mulish', sans-serif;
                color: #212121;
                font-size: 14px;
                line-height: 1.7;
                font-weight: 800;
                text-transform: uppercase;
                letter-spacing: 0.08em;
                margin: 0 13px 0 0;
              }
              .rc-plans-dropdown select.rc-plans-dropdown__select {
                width: 100%;
                max-width: 240px;
                border: 1px solid #BFBFBF;
                color: #333232;
                border-radius: 4px;
                font-family: 'Open Sans', sans-serif;
                background-image: url(https://cdn.shopify.com/s/files/1/0265/5164/8355/files/subscription-dropdown-icon.svg?v=1739856222);
                background-repeat: no-repeat;
                background-position: center right 17px;
                background-size: 14px;
                font-size: 14px;
                line-height: 2;
                padding: 7px 16px;
                cursor: pointer;
                outline: none;
                box-shadow: none;
              }
              @media screen and (max-width: 767px) {
                .rc-plans-dropdown {
                  flex-direction: column;
                  align-items: flex-start;
                }
                .rc-plans-dropdown .rc-plans__label {
                  font-size: 13px;
                  line-height: 1.8;
                  margin: 0 0 3px;
                }
                .rc-plans-dropdown select.rc-plans-dropdown__select {
                  font-size: 13px;
                  padding: 6px 16px;
                  background-size: 13px;
                  background-position: center right 21px;
                  max-width: 230px;
                }
              }
              @media screen and (max-width: 345px) {
                .rc-plans-dropdown select.rc-plans-dropdown__select {
                  background-position: center right 10px;
                  max-width: 200px;
                }
              }
             `);
      }
      const rcRadioIcon = widget.shadowRoot.querySelector("rc-radio-icon");
      if (rcRadioIcon && rcRadioIcon.shadowRoot) {
        injectCSSIntoShadow(rcRadioIcon.shadowRoot, "custom-style-4", `
            .rc-unchecked-icon {
              width: 16px;
              height: 16px;
              border-radius: 100%;
              background-color: #F2F0EF;
            }
            .rc-unchecked-icon rect {
              stroke:#BFBFBF;
            }
            .rc-checked-icon {
              width: 16px;
              height: 16px;
              border-radius: 100%;
              background-color: #A82758;
            }
            .rc-checked-icon circle {
              fill: #fff;
            }
          `);
      }
      const rcRadioIcon2 = widget.shadowRoot.querySelector("[rc-not-selected] rc-radio-icon");
      if (rcRadioIcon2 && rcRadioIcon2.shadowRoot) {
        injectCSSIntoShadow(rcRadioIcon2.shadowRoot, "custom-style-5", `
            .rc-unchecked-icon {
              width: 16px;
              height: 16px;
              border-radius: 100%;
              background-color: #F2F0EF;
            }
            .rc-unchecked-icon rect {
              stroke:#BFBFBF;
            }
            .rc-checked-icon {
              width: 16px;
              height: 16px;
              border-radius: 100%;
              background-color: #A82758;
            }
            .rc-checked-icon circle {
              fill: #fff;
            }
          `);
      }
    });

    observer.observe(widget.shadowRoot, { childList: true, subtree: true });
  } else {
    console.log("Shadow root not found or widget not loaded.");
  }



});